import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { ImageUploadHandlerService } from 'src/app/shared/services/image-upload-handler.service';
import { Validators } from 'src/app/shared/validators';
import { handleBillImagesService } from '../../uploadImage.service';
import { AddBillProviderService } from '../services/bill-provider-add.service';
import { GetBillProviderService } from '../services/bill-provider-get.service';
import { UpdateBillProviderService } from '../services/bill-provider-update.service';

@Component({
  selector: 'app-manage-bill-provider',
  templateUrl: './manage-bill-provider.component.html',
  styleUrls: ['./manage-bill-provider.component.scss'],
})
export class ManageBillProviderComponent implements OnInit {
  editMode;
  id;
  success;
  manageBillProviderForm: FormGroup;
  constructor(
    private translate: TranslateService,
    public formValidator: FormValidatorService,
    private addBillProvider: AddBillProviderService,
    private activatedRoute: ActivatedRoute,
    private getBillProvider: GetBillProviderService,
    private router: Router,
    private updateBillProvider: UpdateBillProviderService,
    private snackBar: MatSnackBar,
    private imageUpload: ImageUploadHandlerService,
    private imageUploadRqst: handleBillImagesService
  ) {
    this.imageUploadRqst.setImagePath('Provider');
  }
  async uploadImage(image: any) {
    this.imageUpload.setUploaderService(this.imageUploadRqst);
    await this.imageUpload.setImageFile(image);
    return await this.imageUpload.upload();
  }
  controllers: any = {
    image: {
      fieldName: 'image',
      fieldType: 'product_image',
      isStaticUI: true,
      defaultValue: '',
      validators: [
        // {
        //   validatorFn: Validators.required,
        //   message: this.translate.instant('FORMS.VALIDATION.TEXT_ONLY', {
        //     field: 'Provider Image',
        //   }),
        // },
      ],
    },
    name: {
      fieldName: 'name',
      defaultValue: null,
      validators: [
        {
          validatorFn: Validators.required,
          message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
            field: 'Provider Name',
          }),
        },
        {
          validatorFn: CustomValidators.customPattern(/^[a-zA-Z]*$/),
          message: this.translate.instant('FORMS.VALIDATION.TEXT_ONLY', {
            field: 'Provider Name',
          }),
        },
        {
          validatorFn: Validators.minLength(2),
          message: this.translate.instant('FORMS.VALIDATION.MINIMUM_LENGTH', {
            field: 'Provider Name',
            value: 2,
          }),
        },
      ],
    },
  };
  async ngOnInit() {
    await this.activatedRoute.params.subscribe(async (a) => {
      if (a['id']) {
        this.editMode = true;
        this.id = a['id'];
        this.getBillProvider.setParams({ ID: this.id });
        const response = await this.getBillProvider.make();
        await this.initForm();

        this.manageBillProviderForm.controls['name'].setValue(response.name);
        this.manageBillProviderForm.controls['image'].setValue(response.image);
      } else {
        this.initForm();
      }
    });
  }

  async initForm() {
    this.manageBillProviderForm = this.formValidator.createForm(
      Object.values(this.controllers)
    );
  }

  async onSubmit() {
    try {
      let imagePath;
      const imgVal = this.manageBillProviderForm.value.image;

      if (typeof imgVal == 'object') {
        imagePath = (await this.uploadImage(imgVal)).location || null;
      } else {
        imagePath = imgVal || null;
      }

      if (this.editMode) {
        this.updateBillProvider.setParams({
          ID: this.id,
          data: {
            name: this.manageBillProviderForm.value.name,
            image: imagePath,
          },
        });
        const res = await this.updateBillProvider.make();
        if (res.success === true) {
          this.success = true;
          this.snackBar.open(`Bill Provider Edited Successfully!`, '', {
            duration: 3000,
          });
        }
      } else {
        this.addBillProvider.setParams({
          ...this.manageBillProviderForm.value,
          image: imagePath,
        });
        const res = await this.addBillProvider.make();
        if (res.success === true) {
          this.success = true;
          this.snackBar.open(`Bill Provider Added  Successfully!`, '', {
            duration: 3000,
          });
        }
      }

      this.router.navigate(['/admin/actions/bill-providers']);
    } catch (err) {
      if (err.validationErrors) {
        const e = err.validationErrors.error;
        for (const error of e) {
          this.formValidator.addError(error.field, 'invalid', error.message);
          this.manageBillProviderForm.controls[error.field].setErrors({
            invalid: error.message,
          });
          this.formValidator.ShowErrors();
        }
      }
    }
  }
  convertControls(name: string) {
    return this.manageBillProviderForm.get(name) as FormControl;
  }
}
